<script setup lang="ts">
import { DropdownMenuTrigger, useForwardPropsEmits } from 'radix-vue'
import type { DropdownMenuTriggerProps } from 'radix-vue'

const props = defineProps<DropdownMenuTriggerProps>()

const forwarded = useForwardPropsEmits(props)
</script>

<template>
  <DropdownMenuTrigger v-bind="forwarded">
    <slot />
  </DropdownMenuTrigger>
</template>
